var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMutedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "96nognw5ya",
    d: "M0 0h7.568v7.19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6.983v-.708c0-.256.227-.464.506-.464s.506.208.506.464v.683c0 .28.038.554.11.817l-.804.738A3.833 3.833 0 0 1 2 6.983",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 11 5.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.106 5.267a4.62 4.62 0 0 0 2.462-1.072l-.716-.657a3.638 3.638 0 0 1-2.352.837c-.923 0-1.825-.345-2.475-.946-.653-.604-1.013-1.405-1.013-2.257V.464C1.012.208.785 0 .506 0 .226 0 0 .208 0 .464v.708c0 1.104.468 2.141 1.318 2.922a4.61 4.61 0 0 0 2.576 1.173l.1.012v.981h-1.93c-.278 0-.505.209-.505.465s.227.464.506.464h4.87c.28 0 .506-.208.506-.464s-.227-.465-.506-.465h-1.93V5.28l.101-.012z",
    fill: "currentColor",
    mask: "url(#2gg3wch1qb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.828 7.076V3.36C3.828 2.056 5.025 1 6.5 1c1.098 0 2.041.585 2.452 1.422L3.83 7.126v-.05M9.172 7.076c0 1.303-1.197 2.36-2.672 2.36-.687 0-1.314-.23-1.787-.606l4.459-4.094v2.34z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    fill: "#FFF",
    d: "m10.103 1 1.06 1.038L2.06 11.29 1 10.237z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "#D8D8D8",
    d: "m10.638 1.513-9.121 9.264"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedIcon);
export default __webpack_public_path__ + "static/media/mutedIcon.f8d1d29548cc527d2f22f460e2221d5d.svg";
export { ForwardRef as ReactComponent };